import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { nameValidator } from 'src/app/core/helpers/custom-name-validator.helper';
import { forbidUppercase } from '../../Helper/custom-form-validators';
import { AccountService } from '../../services/account.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnChanges {
  @Input() showMailVerificationMenu = true;
  submitted = false;
  profilForm!: FormGroup;
  @Output() closeModal = new EventEmitter();
  @Output() openModal = new EventEmitter();
  isDisabled = false;
  extractedPath = '';
  @Input() isCancelOption = false;
  apiProcessing = false;
  is_Triggered: boolean = false;

  signature!: string;
  @Input() userData: any;
  @Output() dataEvent = new EventEmitter<any>();

  /**
   * constructor
   */
  constructor(
    private fb: FormBuilder,
    public commonService: CommonService,
    private toastrService: ToastrService,
    private accountService: AccountService
  ) {
  }

  ngOnInit() {
    this.initiatForm()
  }

  initiatForm() {
    this.profilForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email, forbidUppercase()]],
      display_name:  ['', [Validators.required, Validators.maxLength(15),nameValidator(true,false)]]
    })
  }

  get f() { return this.profilForm?.controls as { [key: string]: AbstractControl }; }

  onSubmit() {
    if (this.profilForm.invalid) {
      this.profilForm.markAllAsTouched()
      this.toastrService.error('Please file all fiels')
    } else {
      this.apiProcessing = true;
      const payload = {
        display_name: this.profilForm.get('display_name')?.value,
      }
      this.accountService.updateUser(this.userData._id, payload).subscribe({
        next: (res: any) => {
          this.toastrService.success('Profile updated successfully')
          this.dataEvent.emit({data:res?.data,updateKey:'display_name'});
          this.closeProfileModal();
          this.apiProcessing = false;
        },
        error: (error: HttpErrorResponse) => {
          this.apiProcessing = false;
          this.toastrService.error('Error updating profile')
        }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.userData) {
      this.profilForm.patchValue(this.userData);
    }
  }

  /**
   * Closes profile modal
   */
  closeProfileModal() {
    this.closeModal.emit();
  }

}
